export default {
  namespaced: true,
  unit: {
    contacts_template_download_error: "Não foi possível baixar a planilha com as seções. Tente novamente.",
    contacts_template_no_sections: "Não há seções disponíveis para criar a planilha.",
    contacts_import_template: "Importar da planilha",
    contacts_template_hint: "Os contatos serão adicionados à lista para edição e salvos ao clicar em Salvar alterações. Digite os telefones como texto para preservar zeros e prefixos.",
    contacts_template_invalid: "Selecione uma planilha XLSX válida de até 5 MB, sem fórmulas e com as colunas Sección, Teléfono, Nombre e Descripción.",
    contacts_template_browser: "Este navegador não permite ler a planilha. Use uma versão recente do Chrome, Edge, Firefox ou Safari.",
    contacts_template_empty: "A planilha não contém contatos.",
    title: "Instalação | Instalações",
    single: "instalação",
    all: "todas os instalações",
    description: "Descrição",
    address_1: "Endereço",
    address_2: "referência",
    exterior_number: "Numero Exterior",
    suburb: "Colônia",
    number: "número interior",
    postal_code: "C.P",
    route: "Rota",
    plate_number: "Placa",
    vin: "VIN",
    driver: "Conductor",
    provider: "Fornecedor",
    owner: "Concessionária",
    company: "Concessionária",
    vehicle: "É um veículo?",
    reaction_patrol: "patrulha de reação",
    allow_virtual_button_alarm: "Permitir botão Virtual",
    active_digital_output: "Permitir saída Digital",
    camera_count: "número de Câmeras",
    timeZone: "fuso horário",
    example: "examplo",
    disable: "Desabilitar instalação",
    disable_comment: "Comentário",
    reactivation_date: "Data de reativação",
    deactivation_date: "Data de desativação",
    required_deactivation_catalog: "O campo 'Catálogo de Desativação de Instalações' é obrigatório",
    required_comment: "O campo 'Comentário' é obrigatório",
    location: "Localização",
    emergency_contacts: "Contatos de Emergência",
    title_app: "Instalação SBO Mobile",
    description_app: "Instalação que será utilizada para gerar incidentes através de SBO Mobile",
    category: "Categoria",
    additional_info: "Informações adicionais",
    key: "Chave",
    value: "Valor",
    import_from_template: "Importar a partir do modelo",
    download_template: "Baixar modelo",
    add_from_form: "Adicionar pelo formulário",
    template: "Modelo",
    select_template: "Selecionar modelo",
    search: "Buscar",
    name: "Nome",
    phone_number: "Telefone",
    section: "Seção",
    add_contact: "Adicionar contato",
    remove_contact: "Remover",
    assign_task: "Atribuir tarefa",
    task_type: "Tipo",
    task_type_inmuebles: "Instalações",
    task_type_form: "Formulário",
    task_type_completar_form: "Completar formulário",
    task_type_create_form_with_relation: 'Criar formulário com relação',
    assigned_task: "Atribuição de imóvel",
    assigned_form_task: "Atribuição de formulário",
    assigned_task_details: "Detalhes da atribuição do imóvel",
    assigned_form_task_details: "Detalhe da atribuição de formulário",
    assigned_security_form_task: "Atribuição de formulário de segurança",
    assigned_security_form_task_details: "Detalhe da atribuição de formulário de segurança",
    panel_failure_task: "Falha do painel",
    panel_failure_task_hint: "Arraste a notificação para um slot para ver o alarme",
    mark_as_done: "Marcar como concluído",
    zone_number: "Zona",
    region_label: "Região",
    task_status: {
      pending: "Pendente",
      done: "Concluído",
      cancelled: "Cancelado"
    },
    enable_nearby_locations: 'Ativar locais próximos',
    distance: 'Distância',
    needs_check: 'Permitir ping',
    getLatLng: 'Obter latitude, longitude e fuso horário do endereço',
    ip_address: 'Endereço IP',
    subnet_mask: 'Máscara de Sub-rede',
    invalid_ip_format: 'Formato de IP inválido',
    invalid_range: 'Faixa inválida',
    ip_required: 'O endereço IP é obrigatório',
    mask_required: 'A máscara de sub-rede é obrigatória',
    attachments: 'Anexos (Máximo 3)',
    no_data: 'Sem dados',
    tenant: 'Tenant',
    center: 'Centro',
    sector: 'Setor',
    id_totem: 'ID Totem',
    totem_key: 'Totem Key',
    id_seproban: 'ID Seproban',
    rems: 'REMS',
    sirh: 'SIRH',
    duplicate_facility_title: 'Já existe uma Instalação com este REMS/SIRH',
    open_existing_new_tab: 'Abrir existente em nova aba',
    merge: 'Realizar Merge',
    duplicate_facility_message: 'Abra a unidade em outra aba para editá-la, ou crie a nova/atualize e realize o merge completo.',
    file_limit_reached: 'Limite atingido',
    file_limit_message: 'Você só pode enviar um máximo de 3 arquivos',
    invalid_file_type: 'Tipo de arquivo inválido',
    invalid_file_message: 'O arquivo "{fileName}" não é um formato permitido',
    downloading_file: 'Baixando arquivo...',
    last_completed_result: 'Resultado da última avaliação aprovada',
    reference_number: 'Referência',
    template_label: 'Modelo',
    no_completed_evaluations: 'Esta instalação ainda não possui uma avaliação aprovada.',
    no_result_found: 'Nenhum resultado encontrado',
    reverse_geocoder_failed: 'Falha na geocodificação reversa',
    bank_data: 'Dados Banco',
    correct_address_warning: "É importante fornecer todos os detalhes do endereço para que as coordenadas (latitude/longitude/fuso horário) possam ser calculadas com precisão.",
    is_disabled: "Está ativado?",
    deactivated_data: "Informações de Desativação",
    entity: "Entidad",
    configuration_date: "Data de configuração",
    installation_date: "Data de instalação",
    c5_router_label: "Etiqueta C5 Roteador",
    router_serial_number: "Número de série do roteador",
    router_model: "Modelo do Roteador",
    router_brand: "Marca do Roteador",
    user: "Usuário",
    password: "Senha",
    ip_vpn: "IP VPN",
    mac_address: "Endereço MAC",
    is_main_unit: "É instalação principal",
    add_filters: "Adicionar filtros",
    toggle_detail_search: "Mostrar ou ocultar a busca dentro do detalhe",
    is_saturday: "Sábado",
    id_cashier: "ID Caixa",
  },
};
